import React from 'react';
import _ from 'lodash';

import {
  Box,
  styled,
  Typography
} from '@mui/material';



const TitleTypography = styled(Typography, {
  shouldForwardProp: prop => prop !== 'direction'
})<{
  direction: IProps['direction'];
}>(({ direction }) => ({
  fontSize: direction === 'horizontal' ? 13 : 20,
  fontWeight: 400,
  minWidth: 138
}));

const TextTypography = styled(Typography, {
  shouldForwardProp: prop => prop !== 'direction'
})<{
  direction: IProps['direction'];
}>(({ direction }) => ({
  fontSize: direction === 'horizontal' ? 13 : 16,
  color: '#99A0B9',
  fontWeight: 400
}));

const ContainerBox = styled(Box, {
  shouldForwardProp: prop => prop !== 'direction'
})<{
  direction: IProps['direction'];
}>(({ theme, direction }) => ({
  marginBottom: theme.spacing(2),
  display: 'flex',
  flexDirection: direction === 'horizontal' ? 'row' : 'column',
  alignItems: direction === 'horizontal' ? 'center' : 'flex-start',
  gap: direction === 'horizontal' ? theme.spacing(2) : theme.spacing(0)
}));



export interface IProps {
  direction?: 'vertical' | 'horizontal';
  title: string;
  text: string | React.ReactNode;
}

export const FC: React.FC<IProps> = props => {
  return (
    <ContainerBox direction={props.direction} >
      <TitleTypography
        direction={props.direction}>
        {props.title}
      </TitleTypography>

      {_.isString(props.text) ? (
        <TextTypography direction={props.direction}>
          {props.text}
        </TextTypography>
      ) : (
        props.text
      )}

    </ContainerBox>
  );
};
